export default __webpack_public_path__ + "static/media/Icon feather-settings.6ac30c6e.svg";